import { HttpEvent } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { FilterModel, ProgramSearchResultModel } from '../../models';

export abstract class BaseDashboardService {
  public filteredResults$: Observable<ProgramSearchResultModel[]>;
  public selectedFilters$: BehaviorSubject<FilterModel | null>;
  public selectedSortOption$: BehaviorSubject<any>;
  public loading: boolean;
  public resetPagination = false;
  public selectedPrograms: any[];
  public selectionCount$: BehaviorSubject<number>;

  public abstract addProgram(programId: string, uuid: string): Observable<boolean>;

  public abstract updateAciSurveyDashboard(aciSurveyDashboard: any[], uuid: string): Observable<boolean>;

  public abstract removeAllPrograms(programIds: string[], uuid: string, programNames: string[]): Observable<any>;

  public abstract removePrograms(programIds: string[], uuid: string, programNames: string[]): Observable<boolean>;

  public abstract getProgramsForMap(filters: any): Observable<ProgramSearchResultModel[]>;

  public abstract filterResults(filters: any, programs: ProgramSearchResultModel[]): Observable<ProgramSearchResultModel[]>;

  public abstract updateSearchResults(results: ProgramSearchResultModel[]): Observable<ProgramSearchResultModel[]>;

  public abstract getSelections(): any[];
  public abstract addSelection(programId: number);
  public abstract removeSelection(programId: number);
}
